import { get } from 'svelte/store';
import { ApiTypes } from '../../enums/api.enum';
import {
  addApiError,
  addBusyApi,
  removeBusyApi,
} from '../../helpers/handle-api';
import type { IRequestSearch } from '../../interfaces/request-search-question.interface';
import { ConfigStore } from '../../store/config';
import { state_apiErrors } from '../../store/state';
import { defaultLogger as logger } from '../../telemetry/logger';
import { trackedFetch } from '../../telemetry/tracked-fetch';
import { UserStateHelper } from '../../helpers/user-state-helper';

/** function to fetch POST /1/question api end point */
export async function postQuestion(
  params: IRequestSearch,
  signal: AbortSignal,
  wasRetried: boolean = false
): Promise<any> {
  try {
    addBusyApi(ApiTypes.postQuestion);
    state_apiErrors.set(
      get(state_apiErrors).filter((x) => x.apiType !== ApiTypes.postQuestion)
    );

    let url;
    if (params.requestType === 'greeting') {
      url = new URL(`${get(ConfigStore).apiBaseUrl}/1/greeting`);
    } else {
      url = new URL(`${get(ConfigStore).apiBaseUrl}/1/question`);
      if (
        params.requestType &&
        get(ConfigStore)?.cacheMsg?.includes(params.requestType)
      ) {
        url.searchParams.set('cache', 'true');
      }
    }
    params.requestType = undefined;

    const tenantId = get(ConfigStore)?.serverConfig?.tenant_id;
    if (tenantId) url.searchParams.set('tenant', tenantId);

    if (get(ConfigStore)?.serverConfig?.id)
      params.config = get(ConfigStore)?.serverConfig?.id;

    UserStateHelper.setRequestProperties(params);

    return trackedFetch(tenantId ?? "", url.href, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      signal,
      body: JSON.stringify(params),
    })
      .then((res) => {
        if (res?.ok) return res;

        if (res?.status === 404 && !wasRetried) {
          return new Promise((resolve) =>
            setTimeout(async () => {
              logger.info('Retrying POST /1/question after 404');
              const value = await postQuestion(params, signal, true);
              resolve(value);
            }, 500)
          );
        }

        throw res;
      })
      .catch(async (res) => {
        let body: any;
        if (res?.response) {
          try {
            body = await res.response.clone().json();
          } catch {
            body = undefined;
          }
        }
        /** error api */
        addApiError({
          apiType: ApiTypes.postQuestion,
          status: res?.status,
          statusText: res?.statusText,
          error: body?.error ?? 'no message',
          message: body?.message,
          noticeCode: body?.notice_code,
          noticeReason: body?.notice_reason,
          errorType: res?.type || res?.name,
        });

        throw res;
      })
      .finally(() => {
        removeBusyApi(ApiTypes.postQuestion);
      });
  } catch (e) {
    //console.error('Error in postQuestionX:', e);
    removeBusyApi(ApiTypes.postQuestion);
    throw e;
  }
}
